<div class="operacoes-container">
  <div class="operacoes-grid">
    <div class="operacoes-lista">
      @for (operacao of operacoes; track operacao.sr_id) {
        <div class="operacao-item" 
             [class.selecionada]="operacaoSelecionada?.sr_id === operacao.sr_id"
             [matTooltip]="('COMPONENTS.OPERACOES.status.' + operacao.en_estado) | transloco"
             (click)="selecionarOperacao(operacao)">
          <span class="status-indicator" [class]="getStatusClass(operacao.en_estado)"></span>
          <span class="operacao-id">{{operacao.vc_service_id}}</span>
        </div>
      }
      @if (operacoes.length === 0) {
        <div class="no-operations"> {{ "COMPONENTS.OPERACOES.no_operations" | transloco }} </div>
      }
    </div>

    @if (operacaoSelecionada) {
      <div class="operacao-expandida visible">
        <app-informacoes-operacao 
          [operacoesInformacoes]="operacoesInformacoes"
          [ofensoresProdutividade]="ofensoresProdutividade"
          [isLoading]="isLoadingInformacoes">
        </app-informacoes-operacao>
      </div>
    }
  </div>
</div>
